import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to Classic Feast",
    title: "From Elegant Events to Casual Gatherings",
    buttonText: "Learn More",
    buttonLink: "Events",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to Classic Feast",
    title: "Exquisite Dining Experience Awaits",
    buttonText: "Explore Menu",
    buttonLink: "Menu-Category",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to Classic Feast",
    title: "Host Unforgettable Events with Us",
    buttonText: "View Venues",
    buttonLink: "Venues",
  },
];

export default home;